

const Footer = () => {
  
   
   
    return (
        <footer className="bg-[#030014] bg-transparent text-white py-6 relative z-10">
        <hr className="my-3 border-gray-700 opacity-50 sm:mx-auto lg:my-6" />
        <span className="block text-sm text-center text-gray-400">
          © 2025{" "}
          <a href="" className="hover:underline text-green-500">
            Noureddine Dev
          </a>
          . All Rights Reserved.
        </span>
      </footer>
    
    );
};

export default Footer;